import * as React from "react";
import ReactDOM from "react-dom";
import { cx } from "utils/join-classnames";
import styles from "./Tooltip.module.scss";

type Props = {
    text: string;
    position?: "top" | "bottom";
    className?: string;
    richContent?: React.ReactNode;
    disabled?: boolean;
    children: React.ReactNode;
};

const Tooltip: React.FC<Props> = ({
    text,
    disabled,
    children,
    className,
    richContent,
    position = "bottom",
}) => {
    const [tooltipVisible, setTooltipVisible] = React.useState<boolean>(false);
    const containerRef = React.useRef<HTMLDivElement>(null);

    const offsetByParentPos = (parentEl: HTMLDivElement) => {
        const rect = parentEl.getBoundingClientRect();
        const scrollLeft =
            window.pageXOffset || document.documentElement.scrollLeft;
        const scrollTop =
            window.pageYOffset || document.documentElement.scrollTop;
        return { top: rect.top + scrollTop, left: rect.left + scrollLeft };
    };

    // Check if tooltip is visible before position calculation to improve performance
    const tooltipPos =
        containerRef.current && tooltipVisible
            ? offsetByParentPos(containerRef.current)
            : {};

    const tooltipJSX = (
        <div
            className={cx(
                styles.tooltip,
                position === "bottom" && styles.tooltip__bottom,
                disabled ? styles.tooltip__disabled : null,
            )}
            style={tooltipPos}
        >
            {richContent || text}
        </div>
    );
    return (
        <div
            className={cx(styles.container, className)}
            onMouseEnter={() => {
                setTooltipVisible(true);
            }}
            onMouseLeave={() => {
                setTooltipVisible(false);
            }}
            ref={containerRef}
        >
            {children}
            {tooltipVisible && ReactDOM.createPortal(tooltipJSX, document.body)}
        </div>
    );
};

export default Tooltip;
